import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FlightObliqueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FlightObliqueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_104_477)">
        <path
          d="M10.9451 20.4401L10.3407 21.0445C10.0325 21.3527 9.51955 21.2877 9.2956 20.9144L7.19582 17.4132C7.14044 17.3193 7.06098 17.2398 6.96706 17.1844L3.46582 15.0846C3.09258 14.8607 3.02997 14.3454 3.33579 14.0396L3.9402 13.4352C4.07986 13.2955 4.27732 13.2233 4.47477 13.2425L8.0314 13.582C8.22885 13.6013 8.42631 13.5291 8.56597 13.3894L9.39433 12.561C9.65439 12.301 9.6544 11.8772 9.39433 11.6171L4.46996 6.69274C4.2099 6.43267 4.20989 6.00886 4.46995 5.7488L5.1442 5.07455C5.34165 4.8771 5.64266 4.82171 5.89791 4.94211L12.9365 8.39761C13.1894 8.5156 13.4928 8.46262 13.6902 8.26516L15.737 6.21836C16.4402 5.51522 17.6008 5.51522 18.2606 6.25688C18.5472 6.58197 18.6917 6.98651 18.6941 7.39347C18.6892 7.83172 18.5207 8.26998 18.1884 8.60229L10.9836 15.807C10.844 15.9467 10.7717 16.1442 10.791 16.3416L11.1329 19.9007C11.1522 20.0981 11.0799 20.2956 10.9403 20.4352"
          fill={isGradient ? `url(#${gradientId})` : fill}
        />
        <path
          d="M19.2815 19.2215L18.6097 19.8933C18.3496 20.1534 17.9258 20.1534 17.6658 19.8933L12.2839 14.5114C12.2839 14.5114 12.2959 14.509 12.3127 14.5066C12.5945 14.4801 14.6196 14.2321 15.9272 12.9246C16.0861 12.7656 16.2354 12.5923 16.363 12.4068L19.4091 18.463C19.5295 18.7182 19.4766 19.0216 19.2767 19.2215"
          fill={isGradient ? `url(#${gradientId})` : fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_104_477">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.27002 0.0900879)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlightObliqueIcon;
